import { ref } from 'vue';
// Set by TransactionDetailPage when a category change is initiated. Consumed by
// AccountPage on mount so it can run its refreshTransaction polling (spinner +
// repeated getBankAccount calls) until the bank-account endpoint reflects the
// new classification — the per-transaction endpoint can update before the
// account-level endpoint does.
// Will be used on other pages in the future, e.g. to show pending classification changes on Money/SA
export const pendingTransactionUpdateId = ref(null);
export const pendingTransactionExpectedClassificationId = ref(null);
